import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import { getOptionsForRolesSelect } from 'selectors/addTeam';
import {
  getShowTipCreditsSettings,
  getShowTipShortageEnabled,
} from 'selectors/session';

import TippableCheckbox from 'features/payroll/components/TippableCheckbox';

import Box from 'components/Box';
import IconButton from 'components/clickables/IconButton';
import RolesSelect from 'components/forms/RolesSelect';
import SelectInput from 'components/forms/SelectInput';
import TextInput from 'components/forms/TextInput';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

@connect((state, props) => ({
  roleOptions: getOptionsForRolesSelect(state, props),
  showTipShortageEnabled: getShowTipShortageEnabled(state),
  showTipCredits: getShowTipCreditsSettings(state),
}))
@cxHelpers('RoleWageRow')
export default class RoleWageRow extends PureComponent {
  static propTypes = {
    wageErrorBorder: PropTypes.bool,
    wageTypeOptions: PropTypes.array.isRequired,
    showLabel: PropTypes.bool.isRequired,
    hideRow: PropTypes.bool.isRequired,
    rowIndex: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    rowData: PropTypes.object.isRequired,
    roleOptions: PropTypes.array.isRequired,
    showTipShortageEnabled: PropTypes.bool.isRequired,
    showTipCredits: PropTypes.bool.isRequired,
    isEmployee: PropTypes.bool.isRequired,
  };

  state = {
    ...this.props.rowData,
  };

  inputProps(name) {
    return {
      name,
      value: this.state[name],
      onChange: partial(this.handleChange, name),
    };
  }

  handleChange = (field, value) =>
    this.setState({ [field]: value }, () => this.props.onChange(this.state));

  render() {
    const currencySign = toI18n('number.currency.format.unit');
    return (
      <Box hide={this.props.hideRow}>
        <Box row className={this.cx(`row${this.props.rowIndex}`)}>
          <Box w={235} inlineBlock mr={12}>
            <Box mb={8}>
              {this.props.showLabel && (
                <Text fs14 fw600 i18n="add_team.individual_drawer.role_label" />
              )}
            </Box>
            <RolesSelect
              disabled={this.state.exiting}
              options={this.props.roleOptions}
              onChange={partial(this.handleChange, 'wageRole')}
              value={this.state.wageRole}
            />
          </Box>
          <Box inlineBlock mr={12}>
            <Box mb={8}>
              {this.props.showLabel && (
                <Text fs14 fw600 i18n="add_team.individual_drawer.wage_label" />
              )}
              {this.props.showLabel && '*'}
            </Box>

            <Box row vcenter>
              <Box mr={12} w={112}>
                <TextInput
                  errorBorder={this.props.wageErrorBorder}
                  name="wage_rate"
                  type="currency"
                  mask="currency"
                  placeholder={`${currencySign}`}
                  disabled={this.state.exiting}
                  {...this.inputProps('wageRate')}
                  valueOnChange
                />
              </Box>
              <Box w={112}>
                {this.props.rowIndex === 0 ? (
                  <SelectInput
                    disabled={this.state.exiting}
                    className={this.cxEl('wage_type')}
                    clearable={false}
                    options={this.props.wageTypeOptions}
                    searchable={false}
                    {...this.inputProps('wageType')}
                  />
                ) : (
                  <Box ml={10}>
                    <Text fs16 fw600>
                      {this.props.wageTypeOptions[0].label}
                    </Text>
                  </Box>
                )}
              </Box>
              {this.props.rowIndex !== 0 && (
                <Box absolute right={0} hide={this.state.exiting}>
                  <IconButton
                    iconColor="grayMediumDark"
                    size="sm"
                    type="mdClose"
                    onClick={this.props.onRemove}
                    className={this.cxEl(`delete_role${this.props.rowIndex}`)}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        {this.props.showTipShortageEnabled &&
          this.props.showTipCredits &&
          this.props.isEmployee && (
            <Box mv={12} row>
              <TippableCheckbox
                wage_rate={this.state.wageRate}
                {...this.inputProps('is_tipped')}
              />
            </Box>
          )}
      </Box>
    );
  }
}
